import { ButtonList } from '@dixa/lib-shared-habla';
import { ampli } from 'lib-shared-tracking';
import { User } from 'lib-shared-types-api';
import { useContext, useState } from 'react';

// eslint-disable-next-line no-restricted-imports
import {
  BanUserModal,
  BanUserModalOnCloseEvent,
} from 'components/shared/banUserModal/banUserModal';
// eslint-disable-next-line no-restricted-imports
import { UnbanUserModal } from 'components/shared/unbanUserModal/unbanUserModal';

import { UserBanOnChatContext } from '../../../../../../userDetails';

const unbanOnChatLabel = 'Unban on chat';
const banOnChatLabel = 'Ban on chat';

export type BanUnbanContactActionProps = {
  /** The user that will be used as target user */
  user: User;
  /** Toggle the parent dropdown between open and closed */
  toggleDropdown: () => void;
};

export function BanUnbanContactAction({
  user,
  toggleDropdown,
}: BanUnbanContactActionProps): JSX.Element {
  const [isBanModalOpen, setIsBanModalOpen] = useState(false);
  const [isUnbanModalOpen, setIsUnbanModalOpen] = useState(false);
  const { isBanned, onBanStatusToggle, isLoadingBanStatus } =
    useContext(UserBanOnChatContext);

  const handleClick = async () => {
    if (isBanned) {
      ampli.contactsUnbanUserClicked({
        channel: 'widget_chat',
      });
      setIsUnbanModalOpen(true);
    } else {
      ampli.contactsBanUserClicked({
        channel: 'widget_chat',
      });
      setIsBanModalOpen(true);
    }

    toggleDropdown();
  };

  const handleModalClose = (event: BanUserModalOnCloseEvent) => {
    setIsBanModalOpen(false);
    setIsUnbanModalOpen(false);

    if (event.response) {
      onBanStatusToggle?.();
    }
  };

  return (
    <>
      <ButtonList.Item
        onClick={handleClick}
        isLoading={isLoadingBanStatus}
        icon="ban"
      >
        {isBanned ? unbanOnChatLabel : banOnChatLabel}
      </ButtonList.Item>

      <BanUserModal
        user={user}
        channel={'widget_chat'}
        isOpen={isBanModalOpen}
        onClose={handleModalClose}
      />

      <UnbanUserModal
        user={user}
        channel={'widget_chat'}
        isOpen={isUnbanModalOpen}
        onClose={handleModalClose}
      />
    </>
  );
}
